import { VtexButton } from '../../../styleguide/VtexButton';
import { useOpenMinicartContextProvider } from '../../openMinicartContextProvider';

type OpenIconContainerProps = {
	children: React.ReactNode;
};

const OpenIconContainer = ({ children }: OpenIconContainerProps) => {
	const { isOpen, setIsOpen } = useOpenMinicartContextProvider();

	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div role="presentation" aria-hidden="true" className={`pa4 pointer vtex-minicart-2-x-openIconContainer`}>
			<VtexButton variation="tertiary" handleClick={() => handleClick && handleClick()}>
				{children}
			</VtexButton>
		</div>
	);
};

export default OpenIconContainer;
